module.exports = __webpack_public_path__ + "static/media/averta.8317433b.woff";